/**
 * Mirror of Gravy::OrderInitiator. Keep values in sync with
 * apps/gravy/lib/gravy/core/app/constants/gravy/order_initiator.rb.
 */
export enum OrderInitiatorValues {
  MCP_HANDOFF = 'mcp_handoff',
}
